define([
	'components/utilities/utilities',
	'libs/skrollr'
], function (utils, skrollr) {
	'use strict';

	/**
	 * Parallax
	 * A plugin that demos the parallax feature with the Skrollr plugin.
	 * @version 2.0.0
	 * @exports parallax
	 */
	var parallax = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initParallax();
		},


		/**
		 * Initate parallax.
		 * @private
		 */
		_initParallax: function () {
			var that = this;

			this._onLayoutResize();

			utils.addEventListener(window, 'resize', function () {
				that._onLayoutResize();
			});
		},


		/**
		 * Updates the skrollr parallax effect when layout is resized.
		 * @private
		 */
		_onLayoutResize: function () {
			var windowsize = (window.innerWidth || document.documentElement.clientWidth);

			if ((navigator.userAgent.toLowerCase().indexOf('ipad') === -1 && navigator.userAgent.toLowerCase().indexOf('android') === -1) && windowsize > 768) {
				if (this.skrollrInstance !== undefined) {
					this.skrollrInstance.destroy();
				}

				this.skrollrInstance = skrollr.init({
					forceHeight: false,
					smoothScrolling: false,
					mobileCheck: function () {
						return false;
					}
				});
			}
		}
	};


	return parallax;
});


//////////////////
// WEBPACK FOOTER
// ./components/parallax/parallax.js
// module id = 15
// module chunks = 0